<template>
  <el-dialog
    title="选择调拨售后工单"
    :visible.sync="visible"
    width="960px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.dealOrderCode"
        placeholder="请输入调拨单号"
        style="width: 200px"
        clearable=""
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        :resizable="false"
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.postSaleOrderId"
            :label="row.postSaleOrderId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="售后工单号"
        width="160">
        <template slot-scope="{row}">
          {{ row.postSaleOrderNumber }}
        </template>
      </el-table-column>
      <el-table-column
        label="订单编号"
        width="160"
        prop="dealOrderCode"></el-table-column>
      <!-- <el-table-column
        label="收件人">
        <template slot-scope="{row}">
          <span v-if="row.receiverName">{{ row.receiverName }}</span>
          <span>-</span>
          <span v-if="row.receiverPhone">{{ row.receiverPhone }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        label="明细">
        <template slot-scope="{row}">
          <el-popover
            placement="right"
            trigger="hover">
            <el-table
              border=""
              :data="row.details">
              <el-table-column
                width="180"
                property="productName"
                label="商品名称"></el-table-column>
              <el-table-column
                width="80"
                property="productNumber"
                label="商品编码"></el-table-column>
              <el-table-column
                property="goodsCount"
                label="退货数量"></el-table-column>
              <el-table-column
                property="returnedGoodsCount"
                label="已退数量"></el-table-column>
            </el-table>
            <el-link
              slot="reference"
              style="font-size: 12px"
              type="primary">查看</el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        prop="reason"></el-table-column>
      <el-table-column
        width="90"
        label="售后类别">
        <template slot-scope="{row}">
          <span v-if=" row.type === 2">退货</span>
          <span v-if=" row.type === 3">换货</span>
          <span v-if=" row.type === 4">补发货</span>
          <span v-if=" row.type === 9">其他</span>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        width="90">
        <template slot-scope="{row}">
          {{ row.status | aftersaleStatus() }}
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="140">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat() }}
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
    <!-- <notag-returen-modal ref="notag" /> -->
  </el-dialog>
</template>
<script>
// import NotagReturenModal from './notag-returen-modal.vue'

export default {
  name: 'OrderSelectModal',
  components: { },
  props: {
    callback: Function,
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        dealOrderCode: '',
        receiverName: '',
        receiverPhone: '',
        sourceBillType: 2,
        // code: '',
        // type: 1,
        status: 0
        // sourceWarehouseNo: null
      },
      total: 0,
      current: {}
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config.pageNum = 1
      this.total = 0
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.postSaleOrderId) {
        this.$message.error('请选择一个调拨售后工单')
        return
      }
      this.callback && this.callback(this.current)
      // this.getoutstockorder(this.current.id)
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('goodsreturn/getpostsaleorders', {
        payload: {
          ...this.config,
          ...this.options
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      // this.options = options
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
